var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mail-list" } }, [
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c("a-input-search", {
              staticStyle: { width: "100% !important" },
              attrs: { placeholder: _vm.$t("message.query") },
              on: {
                input: function ($event) {
                  return _vm.onSearch($event)
                },
              },
              model: {
                value: _vm.searchValue,
                callback: function ($$v) {
                  _vm.searchValue = $$v
                },
                expression: "searchValue",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "toolbar" }, [
              _c(
                "div",
                { staticClass: "tabs" },
                [
                  _c(
                    "a-tooltip",
                    {
                      staticClass: "item",
                      class: [_vm.selected === "all" && "selected"],
                      attrs: { placement: "top", title: _vm.$t("message.all") },
                      on: { click: _vm.mailListAll },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "material-icons filter-icons" },
                        [_vm._v("all_inbox")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "count" }, [
                        _vm._v(_vm._s(_vm.allMailCounts)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.selectedMenu === "My"
                    ? _c(
                        "a-tooltip",
                        {
                          staticClass: "item",
                          class: [_vm.selected === "unread" && "selected"],
                          attrs: {
                            placement: "top",
                            title: _vm.$t("mail.unread"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.mailListUnread("")
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "material-icons filter-icons" },
                            [_vm._v("mark_email_unread")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "count" }, [
                            _vm._v(_vm._s(_vm.unreadMailCount)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedMenu === "My"
                    ? _c(
                        "a-tooltip",
                        {
                          staticClass: "item",
                          class: [_vm.selected === "unreply" && "selected"],
                          attrs: {
                            placement: "top",
                            title: _vm.$t("mail.unreply"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.getUnReplyMails("")
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "material-icons filter-icons" },
                            [_vm._v("unsubscribe")]
                          ),
                          _vm._v(" "),
                          _vm.unReplyMailCount > 0
                            ? _c("span", { staticClass: "count" }, [
                                _vm._v(_vm._s(_vm.unReplyMailCount)),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "material-icons",
                      staticStyle: { "font-size": "20px", cursor: "pointer" },
                      on: { click: _vm.refresh },
                    },
                    [_vm._v("replay")]
                  ),
                  _vm._v(" "),
                  _vm.selectedMenu === "My"
                    ? _c(
                        "a-popover",
                        {
                          attrs: {
                            id: "mail-multi-btn",
                            placement: "bottom",
                            trigger: "click",
                          },
                        },
                        [
                          _c(
                            "md-icon",
                            { staticStyle: { cursor: "pointer" } },
                            [_vm._v("more_horiz")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "mail-detail",
                                  on: {
                                    click: function ($event) {
                                      return _vm.markAsRead()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("mark_email_read")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "mail-detail-item" },
                                    [_vm._v(_vm._s(_vm.$t("mail.markAsRead")))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("md-progress-bar", {
          staticClass: "md-accent",
          attrs: { "md-mode": _vm.isDeterminate },
        }),
        _vm._v(" "),
        _vm.filterMailList.length === 0
          ? _c("NoMessage", { attrs: { desc: _vm.$t("mail.mailNotFound") } })
          : _c(
              "div",
              { staticClass: "mails" },
              [
                _vm._l(_vm.filterMailList, function (email) {
                  return _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "item",
                        class: [
                          _vm.selectedMailThreadId === email.thread_id &&
                            "selected",
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.changeSelectedMail(email.thread_id)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "avatar" }, [
                          _c("span", { staticClass: "avatar-name" }, [
                            _vm._v(
                              _vm._s(
                                email.sender
                                  ? email.sender.slice(0, 1).toUpperCase()
                                  : ""
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "metas" }, [
                          _c(
                            "div",
                            { staticClass: "left" },
                            [
                              _c(
                                "a-tooltip",
                                { attrs: { title: email.sender } },
                                [
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          email.sender.length > 15
                                            ? email.sender.substring(0, 30) +
                                                "..."
                                            : email.sender
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "subject" }, [
                                _c("span", { staticClass: "subject-name" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("headBar.subject")) + ": "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(email.subject))]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "right" }, [
                            _vm._v(_vm._s(_vm.getTime(email.created_at))),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                }),
                _vm._v(" "),
                _vm.isVisibleLoadMore()
                  ? _c(
                      "div",
                      {
                        staticClass: "material-icons get-mails",
                        on: { click: _vm.getLoadMore },
                      },
                      [
                        _vm._v(
                          "\n                add_circle_outline\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }